import { Box } from '@mui/material'
import SimpleTab from 'components/SimpleTab'
import { BsBoxes } from "react-icons/bs";
import { BsBoxSeam } from "react-icons/bs";
import React from 'react'
import ProductsInMachine from './ProductsInMachine';
import ProductWiseSales from './ProductWiseSales';

const ProductAnalytics = () => {
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <SimpleTab
        header1="Products in machines"
        header2="Product-wise sales"
        icon1={<BsBoxes/>}
        icon2={<BsBoxSeam/>}
        child1={<ProductsInMachine />}
        child2={<ProductWiseSales/>}
      />
    </Box>
  )
}

export default ProductAnalytics